<template lang="pug">
  include /mixins
  div
    +b.tag-filter-title.SPAN {{ filter.attribute.title }}:
    template(v-for='val in filter.attribute.values')
      +b.vacancy-tag-wrap.SPAN(
        v-if='!val.hasOwnProperty("is_valid") || val.is_valid'
        :class='{"is-active": isChecked(val.props.label)}'
      )
        +e.element.INPUT(
          type='checkbox'
          :value='val.props.label',
          :name='filter.attribute.label'
          v-model='checked'
          :input-label='val.props.title',
          :id='`${filter.attribute.label}:${val.id}`'
          :disabled='!isAvailable(val.id, val.props.label)'
          @change='submit()'
        )
        +b.LABEL.vacancy-tag(
          :for='`${filter.attribute.label}:${val.id}`'
        )
          +b.hot-vacancy-label(
            v-if='val.props.is_hot'
          )
            +e.icon.IMG(
              :alt="_('Горячая вакансия')"
              src='/static/img/vacancies/fire.svg'
            )
          span {{ val.props.title }}
        // for available filters debug
        //- span(style='color: red') {{ isAvailable(val.id, val.props.label) }} {{ hasActive(val.props.label) }}
</template>
<script>
import pathOr from 'ramda/src/pathOr'

const LABEL_MAP = {
  country: [['props', 'title']],
  city: [['props', 'settlement_type_description'], ['props', 'description']],
  position: [['props', 'title']],
  tag: [['props', 'title']],
}

export default {
  name: 'CheckboxRenderer',
  props: ['value', 'filter', 'available'],
  data() {
    return {
      checked: [],
    }
  },
  watch: {
    value(nval) {
      this.checked = this.normalize(nval)
    },
  },
  mounted() {
    this.checked = this.normalize(this.value)
  },
  methods: {
    isChecked(label) {
      return this.checked.includes(label)
    },
    getLabel(object) {
      const l = LABEL_MAP[this.filter.attribute.label]
      if (l) {
        const gh = l.reduce((acc, obj) => {
          acc.push(pathOr('', obj, object))
          return acc
        }, [])
        return gh.join(' ')
      }
      return object
    },
    submit() {
      this.$emit('input', this.checked)
    },
    isAvailable(id, label) {
      // if (!this.available.attributes) return true
      const customFilter = this.available[this.filter.attribute.label]
      if (customFilter) {
        const a = customFilter.find(el => el == id)
        if (!a && this.hasActive(label)) return true
        return a
      }
      return true
      // const a = this.available.attributes.find(el => el == id)
      // if (!a && this.hasActive(label)) return true
      // return a
    },
    hasActive(val) {
      return this.checked.includes(val)
    },
    normalize(value) {
      if (!value) return []
      const checked = this.filter.attribute.values.filter(el => value.find(v => v == el.props.label)).map(el => el.props.label)
      return checked
    },
  },
}
</script>
